import store from '@/store/index.js';

export const publicPages = [
  'room_timetable',
  'login',
  'google_oauth_handling',
  'teach_table_selector',
  'teach_table',
  'graduate_teach_table_selector',
  'graduate_teach_table',
  'statistic_split_curr',
  'information',
  'report_student',
  'report_x_student',
  'report_student_disability',
  'report_student_islam',
  'report_student_inter',
];

export const userPages = [
  'main_menu',
];

export const studentPages = [
  'home',
  'pre_registration',
  'registration',
  'student_timetable',
  'student_exam_timetable',
  'student_exam_timetable_seat',
  'payment',
  'payment_slip',
  'questionnaire',
  'maintain_and_leave',
];

export const futureInnovationStudentPages = [
  ...studentPages,
  'registration_future_innovation',
];

export const xStudentPages = [
  'home',
  'registration_x',
  'student_timetable',
  'student_exam_timetable',
  'student_exam_timetable_seat',
  'payment',
  'payment_slip',
  'questionnaire',
  'english_submit',
  'maintain_and_leave',
];

export const adminPages = [
  'config_schedule_permission',
  'home',
  'graduate_officer_menu',
  'surrogate_student',
  'config_teach_table',
  'config_academic',
  'config_payment',
  'config_medicine',
  'config_individual_tuition_fee',
  'config_graduate_separate_thesis_credit',
  'config_graduate_curriculum_fee',
  'registration_for_officer',
  'payment_officer',
  'payment_slip',
  'english_submit_list',
  'english_submit_verify',
  'student_timetable',
  'student_exam_timetable',
  'student_exam_timetable_seat',
  'report_student_not_registered',
  'student_debt_report',
  'registration_queue',
  'academic_data_edit',
];

export const registrarOfficerPages = [
  'config_schedule_permission',
  'home',
  'graduate_officer_menu',
  'surrogate_student',
  'config_teach_table',
  'config_academic',
  'config_payment',
  'config_medicine',
  'config_individual_tuition_fee',
  'config_graduate_separate_thesis_credit',
  'config_graduate_curriculum_fee',
  'registration_for_officer',
  'payment_officer',
  'payment_slip',
  'english_submit_list',
  'english_submit_verify',
  'student_timetable',
  'student_exam_timetable',
  'student_exam_timetable_seat',
  'report_student_not_registered',
  'student_debt_report',
  'registration_queue',
  'academic_data_edit',
];

// เจ้าหน้าที่การเงินเข้าถึงเฉพาะงานชำระเงิน ไม่รวมงานทะเบียนหรือหน้าตั้งค่าอื่น
export const financeOfficerPages = [
  'payment_officer',
  'payment_slip',
];

export const facultyOfficerPages = [
  'config_teach_table',
];

// เจ้าหน้าที่คณะ (10) ดูข้อมูลการชำระเงินได้อย่างเดียว
export const facultyPaymentViewerPages = [
  'payment_officer',
];

export const medicineFacultyOfficerPages = [
  'config_medicine',
];

export const teacherPages = [
  'config_teach_table',
  'registration_queue',
];

export function check_permission(route_name) {
  // Public
  if (publicPages.some(page => route_name.includes(page))) {
    return true;
  }

  // User
  else if (
    userPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen
  ) {
    return true;
  }

  // Student
  else if (
    studentPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.surrogated_student_info &&
    store.state.user.surrogated_student_info.payload.ticket.privilege == 80
  ) {
    return true;
  }

  // Future Innovation Student
  else if (
    futureInnovationStudentPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.surrogated_student_info &&
    store.state.user.is_future_innovation_student
  ) {
    return true;
  }

  // XStudent
  else if (
    xStudentPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.surrogated_student_info &&
    store.state.user.surrogated_student_info.payload.ticket.privilege == 85
  ) {
    return true;
  }

  // Admin
  else if (
    adminPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.user_info.payload.ticket.privilege == 91
  ) {
    return true;
  }

  // Registrar Officer
  else if (
    registrarOfficerPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    (store.state.user.user_info.payload.ticket.privilege == 40 || store.state.user.user_info.payload.ticket.privilege == 45)
  ) {
    return true;
  }

  // Finance Officer
  else if (
    financeOfficerPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.user_info.payload.ticket.privilege == 30
  ) {
    return true;
  }

  // Faculty Officer
  else if (
    facultyOfficerPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    (store.state.user.user_info.payload.ticket.privilege == 10 || store.state.user.user_info.payload.ticket.privilege == 19)
  ) {
    return true;
  }

  // Faculty Payment Viewer
  else if (
    facultyPaymentViewerPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.user_info.payload.ticket.privilege == 10
  ) {
    return true;
  }

  // Medicine Faculty Officer
  else if (
    medicineFacultyOfficerPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.user_info.payload.ticket.privilege == 10 &&
    store.state.user.user_info.faculty_id == 16
  ) {
    return true;
  }

  // Teacher
  else if (
    teacherPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.user_info.payload.ticket.privilege == 60
  ) {
    return true;
  }


  else {
    return false;
  }
}
